import { render, staticRenderFns } from "./DevInfoEnView.vue?vue&type=template&id=2be9d74b&"
import script from "./DevInfoEnView.vue?vue&type=script&lang=ts&"
export * from "./DevInfoEnView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports